// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lead-genearation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3%;
}
.lead-gen-main-component-row {
  width: 100%;
  gap: 10%;
  display: flex;
  justify-content: center;
}
.connect-with-header {
  font-family: Roboto;
  font-weight: 700;
  font-style: Bold;
  font-size: 30px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #000000;
}
.whether-text-row {
  text-align: start;
  margin-top: 10px;
}
.get-in-touch-row-lead {
  display: flex;
  gap: 7px;
  flex-direction: column;
}
.book-an-appoint-btn-row {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
}
.connect-image-and-text-container {
  width: 22%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: 80vh !important;
}
.whether-your-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 19px;
  line-height: 26.6px;
  letter-spacing: 0%;
  text-align: center;
  color: var(--Colors-Text-400, #3b3f3d);
}
.form-generation-card {
  border-radius: 10px !important;
  background: #ffffff !important;
  box-shadow: 2px 2px 30px 0px #0000000d !important;
  padding: 10px !important;
}
.tell-us-text {
  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 18px !important;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000 !important;
}
.this-is-information-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px !important;
  line-height: 19px;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #5b5e5d) !important;
}
.lead-radio-button-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000 !important;
}
.book-an-oppointment {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px !important;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration: underline !important;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #d2042d !important;
  cursor: pointer;
}
.search-header-text-row {
  gap: 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.plan-build-sub-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 21.6px;
  letter-spacing: 0%;
  color: var(--Colors-Text-400, #3b3f3d);
}
.add-campaign-span-text {
  font-weight: 600;
  font-style: SemiBold;
}
/* Make textarea relative */
.billboard-text-area .ant-input-textarea {
  position: relative;
}

/* Position count inside bottom-right */
.billboard-text-area .ant-input-data-count {
  font-size: 12px;
  color: #999;
  pointer-events: none;
}

/* Add padding so text doesn't overlap the counter */
.billboard-text-area textarea {
  padding-bottom: 28px !important;
}
.get-in-touch-col {
  width: 40%;
}
.lead-textt-area textarea {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-500, #0a0f0d);
}
.lead-textt-area textarea::placeholder {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #6a6a6a;
}
.lead-textt-area.floating-label {
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
}
.sample .floating-text-area-container.middle label.floating-label {
  padding-top: 8px !important;
}
.our-team-get-back-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: #d2042d;
}
.success-card-lead-row {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.success-green-icon {
  width: 60px !important;
  height: auto !important;
  margin-bottom: 15px !important;
}
.thanks-your-info-row {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 10px;
}
.search-build-header-row {
  width: 100%;
}
.check-box-lead-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-top: 10px;
  align-items: center;
}
.check-box-lead-col {
  width: 5%;
}
.check-box-form-item.ant-form-item {
  margin: 0px !important;
}
.common-styling-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 15px !important;
}
.common-styling-col {
  width: 47%;
  padding: 0px !important;
}
.common-styling-col-right {
  width: 50% !important;
  padding: 0px !important;
}
.this-is-information-text-row {
  margin-top: 10px;
}
.success-back-to-home-row {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 20px;
}
.country-select {
  width: 48% !important;
}
.combination-of-mobile {
  width: 49%;
  display: flex;
  flex-direction: row;
  gap: 5px;
}
.select-phone-number {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}
/* Keeps selected value in one line */
.ant-select-selection-item,
.select-phone-number {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

/* Prevent text wrapping */
.ant-select-selection-item span {
  white-space: nowrap;
}

/* Optional: handle overflow gracefully */
.ant-select-selection-item {
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 1026px) and (max-width: 1440px) {
  .connect-with-header {
    font-size: 25px !important;
  }
  .get-in-touch-col {
    width: 50%;
  }
  .connect-image-and-text-container {
    width: 25%;
  }
  .common-styling-col {
    width: 45% !important;
  }
  .lead-gen-main-component-row {
    gap: 5% !important;
  }
}
@media (min-width: 769px) and (max-width: 1025px) {
  .get-in-touch-col {
    width: 55%;
  }
  .connect-image-and-text-container {
    width: 35%;
  }
  .connect-with-header {
    font-size: 22px !important;
  }
  .lead-gen-main-component-row {
    gap: 5% !important;
  }
  .common-styling-col-right {
    width: 47% !important;
  }
  .country-select {
    width: 100% !important;
  }
}
@media (max-width: 768px) {
  .lead-gen-main-component-row {
    width: 100%;
    gap: 2%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .connect-image-and-text-container {
    width: 100%;
  }
  .get-in-touch-col {
    width: 100%;
  }
  .search-build-header-row {
    margin: 20px 0px 20px 0px;
  }
  .lead-genearation-container {
    margin-top: 10% !important;
  }
  .connect-with-header {
    font-size: 25px !important;
  }
}
@media (max-width: 426px) {
  .common-styling-row {
    flex-direction: column;
  }
  .common-styling-col {
    width: 100%;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .check-box-lead-col {
    width: 3%;
  }
}
@media (min-width: 321px) and (max-width: 425px) {
  .connect-with-header {
    font-size: 19px !important;
  }
  .plan-build-sub-text {
    font-size: 14px;
  }
  .tell-us-text {
    font-size: 17px !important;
  }
  .book-an-oppointment {
    font-size: 14px !important;
  }
  .lead-radio-button-text {
    font-size: 15px !important;
  }
  .common-styling-col-right {
    width: 100% !important;
  }
  .combination-of-mobile {
    flex-direction: column;
    gap: 20px;
  }
  .country-select {
    width: 100% !important;
  }
}
@media (min-width: 0px) and (max-width: 320px) {
  .connect-with-header {
    font-size: 16px !important;
  }
  .plan-build-sub-text {
    font-size: 14px;
  }
  .tell-us-text {
    font-size: 14px !important;
  }
  .book-an-oppointment {
    font-size: 14px !important;
  }
  .lead-radio-button-text {
    font-size: 15px !important;
  }
  .check-box-lead-row {
    gap: 10px !important;
    align-items: flex-start !important;
  }
  .combination-of-mobile {
    flex-direction: column;
    gap: 20px;
  }
  .country-select {
    width: 100% !important;
  }
  .success-green-icon {
    width: 50px !important;
  }
  .this-is-information-text {
    font-size: 13px !important;
  }
}
.phone-with-prefix .ant-input-group-addon {
  padding: 0px !important; /* 👈 ADD PADDING HERE */
  border-color: transparent !important;
}
.phone-with-prefix {
  padding: 0.625rem 0.5rem !important;
}

.phone-with-prefix.ant-select-selector {
  background-color: transparent !important;
  border-color: transparent !important;
}
.phone-with-prefix .ant-input-group > .ant-input-group-addon {
  background: #fcfcfc !important;
  padding-left: 5px !important;
}
.country-select-dropdown {
  padding: 4px;
  width: 15% !important;
}

.country-option-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border-radius: 6px;
}

.country-option-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.country-name {
  font-size: 13px;
  font-weight: 500;
}

.country-code {
  font-size: 13px;
  font-weight: 600;
  color: #ff4d4f;
}

/* Hover */
.country-select-dropdown .ant-select-item-option:hover {
  background-color: #ffecee;
}

/* Selected */
.country-select-dropdown .ant-select-item-option-selected {
  background-color: #fff1f2 !important;
}
/* Hide selected value when dropdown is open */
.country-select.ant-select-open .ant-select-selection-item {
  display: none !important;
}

/* Ensure search input is visible */
.country-select.ant-select-open .ant-select-selection-search {
  display: inline-flex !important;
}

.lead-success-container {
  min-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3%;
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/lead-generation-form/LeadGenerationForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,QAAQ;EACR,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,iDAAiD;EACjD,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,iDAAiD;AACnD;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA,oDAAoD;AACpD;EACE,+BAA+B;AACjC;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA,qCAAqC;AACrC;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,WAAW;IACX,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,oBAAoB;IACpB,kCAAkC;EACpC;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,uBAAuB,EAAE,wBAAwB;EACjD,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,oCAAoC;AACtC;AACA,8CAA8C;AAC9C;EACE,wBAAwB;AAC1B;;AAEA,mCAAmC;AACnC;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".lead-genearation-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 3%;\n}\n.lead-gen-main-component-row {\n  width: 100%;\n  gap: 10%;\n  display: flex;\n  justify-content: center;\n}\n.connect-with-header {\n  font-family: Roboto;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 30px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-align: center;\n  color: #000000;\n}\n.whether-text-row {\n  text-align: start;\n  margin-top: 10px;\n}\n.get-in-touch-row-lead {\n  display: flex;\n  gap: 7px;\n  flex-direction: column;\n}\n.book-an-appoint-btn-row {\n  margin-top: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n.connect-image-and-text-container {\n  width: 22%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-height: 80vh !important;\n}\n.whether-your-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 19px;\n  line-height: 26.6px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: var(--Colors-Text-400, #3b3f3d);\n}\n.form-generation-card {\n  border-radius: 10px !important;\n  background: #ffffff !important;\n  box-shadow: 2px 2px 30px 0px #0000000d !important;\n  padding: 10px !important;\n}\n.tell-us-text {\n  font-family: Roboto;\n  font-weight: 600;\n  font-style: SemiBold;\n  font-size: 18px !important;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000000 !important;\n}\n.this-is-information-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px !important;\n  line-height: 19px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #5b5e5d) !important;\n}\n.lead-radio-button-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #000000 !important;\n}\n.book-an-oppointment {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px !important;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-decoration: underline !important;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  color: #d2042d !important;\n  cursor: pointer;\n}\n.search-header-text-row {\n  gap: 5px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.plan-build-sub-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 21.6px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-400, #3b3f3d);\n}\n.add-campaign-span-text {\n  font-weight: 600;\n  font-style: SemiBold;\n}\n/* Make textarea relative */\n.billboard-text-area .ant-input-textarea {\n  position: relative;\n}\n\n/* Position count inside bottom-right */\n.billboard-text-area .ant-input-data-count {\n  font-size: 12px;\n  color: #999;\n  pointer-events: none;\n}\n\n/* Add padding so text doesn't overlap the counter */\n.billboard-text-area textarea {\n  padding-bottom: 28px !important;\n}\n.get-in-touch-col {\n  width: 40%;\n}\n.lead-textt-area textarea {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-500, #0a0f0d);\n}\n.lead-textt-area textarea::placeholder {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #6a6a6a;\n}\n.lead-textt-area.floating-label {\n  font-size: 12px;\n  font-weight: 400;\n  color: #6b7280;\n}\n.sample .floating-text-area-container.middle label.floating-label {\n  padding-top: 8px !important;\n}\n.our-team-get-back-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: #d2042d;\n}\n.success-card-lead-row {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.success-green-icon {\n  width: 60px !important;\n  height: auto !important;\n  margin-bottom: 15px !important;\n}\n.thanks-your-info-row {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 10px;\n}\n.search-build-header-row {\n  width: 100%;\n}\n.check-box-lead-row {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  margin-top: 10px;\n  align-items: center;\n}\n.check-box-lead-col {\n  width: 5%;\n}\n.check-box-form-item.ant-form-item {\n  margin: 0px !important;\n}\n.common-styling-row {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 15px !important;\n}\n.common-styling-col {\n  width: 47%;\n  padding: 0px !important;\n}\n.common-styling-col-right {\n  width: 50% !important;\n  padding: 0px !important;\n}\n.this-is-information-text-row {\n  margin-top: 10px;\n}\n.success-back-to-home-row {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  margin-top: 20px;\n}\n.country-select {\n  width: 48% !important;\n}\n.combination-of-mobile {\n  width: 49%;\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n}\n.select-phone-number {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n/* Keeps selected value in one line */\n.ant-select-selection-item,\n.select-phone-number {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n/* Prevent text wrapping */\n.ant-select-selection-item span {\n  white-space: nowrap;\n}\n\n/* Optional: handle overflow gracefully */\n.ant-select-selection-item {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (min-width: 1026px) and (max-width: 1440px) {\n  .connect-with-header {\n    font-size: 25px !important;\n  }\n  .get-in-touch-col {\n    width: 50%;\n  }\n  .connect-image-and-text-container {\n    width: 25%;\n  }\n  .common-styling-col {\n    width: 45% !important;\n  }\n  .lead-gen-main-component-row {\n    gap: 5% !important;\n  }\n}\n@media (min-width: 769px) and (max-width: 1025px) {\n  .get-in-touch-col {\n    width: 55%;\n  }\n  .connect-image-and-text-container {\n    width: 35%;\n  }\n  .connect-with-header {\n    font-size: 22px !important;\n  }\n  .lead-gen-main-component-row {\n    gap: 5% !important;\n  }\n  .common-styling-col-right {\n    width: 47% !important;\n  }\n  .country-select {\n    width: 100% !important;\n  }\n}\n@media (max-width: 768px) {\n  .lead-gen-main-component-row {\n    width: 100%;\n    gap: 2%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n  }\n  .connect-image-and-text-container {\n    width: 100%;\n  }\n  .get-in-touch-col {\n    width: 100%;\n  }\n  .search-build-header-row {\n    margin: 20px 0px 20px 0px;\n  }\n  .lead-genearation-container {\n    margin-top: 10% !important;\n  }\n  .connect-with-header {\n    font-size: 25px !important;\n  }\n}\n@media (max-width: 426px) {\n  .common-styling-row {\n    flex-direction: column;\n  }\n  .common-styling-col {\n    width: 100%;\n  }\n}\n@media (min-width: 426px) and (max-width: 768px) {\n  .check-box-lead-col {\n    width: 3%;\n  }\n}\n@media (min-width: 321px) and (max-width: 425px) {\n  .connect-with-header {\n    font-size: 19px !important;\n  }\n  .plan-build-sub-text {\n    font-size: 14px;\n  }\n  .tell-us-text {\n    font-size: 17px !important;\n  }\n  .book-an-oppointment {\n    font-size: 14px !important;\n  }\n  .lead-radio-button-text {\n    font-size: 15px !important;\n  }\n  .common-styling-col-right {\n    width: 100% !important;\n  }\n  .combination-of-mobile {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .country-select {\n    width: 100% !important;\n  }\n}\n@media (min-width: 0px) and (max-width: 320px) {\n  .connect-with-header {\n    font-size: 16px !important;\n  }\n  .plan-build-sub-text {\n    font-size: 14px;\n  }\n  .tell-us-text {\n    font-size: 14px !important;\n  }\n  .book-an-oppointment {\n    font-size: 14px !important;\n  }\n  .lead-radio-button-text {\n    font-size: 15px !important;\n  }\n  .check-box-lead-row {\n    gap: 10px !important;\n    align-items: flex-start !important;\n  }\n  .combination-of-mobile {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .country-select {\n    width: 100% !important;\n  }\n  .success-green-icon {\n    width: 50px !important;\n  }\n  .this-is-information-text {\n    font-size: 13px !important;\n  }\n}\n.phone-with-prefix .ant-input-group-addon {\n  padding: 0px !important; /* 👈 ADD PADDING HERE */\n  border-color: transparent !important;\n}\n.phone-with-prefix {\n  padding: 0.625rem 0.5rem !important;\n}\n\n.phone-with-prefix.ant-select-selector {\n  background-color: transparent !important;\n  border-color: transparent !important;\n}\n.phone-with-prefix .ant-input-group > .ant-input-group-addon {\n  background: #fcfcfc !important;\n  padding-left: 5px !important;\n}\n.country-select-dropdown {\n  padding: 4px;\n  width: 15% !important;\n}\n\n.country-option-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 10px;\n  border-radius: 6px;\n}\n\n.country-option-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.country-name {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.country-code {\n  font-size: 13px;\n  font-weight: 600;\n  color: #ff4d4f;\n}\n\n/* Hover */\n.country-select-dropdown .ant-select-item-option:hover {\n  background-color: #ffecee;\n}\n\n/* Selected */\n.country-select-dropdown .ant-select-item-option-selected {\n  background-color: #fff1f2 !important;\n}\n/* Hide selected value when dropdown is open */\n.country-select.ant-select-open .ant-select-selection-item {\n  display: none !important;\n}\n\n/* Ensure search input is visible */\n.country-select.ant-select-open .ant-select-selection-search {\n  display: inline-flex !important;\n}\n\n.lead-success-container {\n  min-height: 80vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 3%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
